//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const queryString = require('query-string');
var format = require('string-template');
var loadjs = require('loadjs');
var numeral = require('numeral')
import { generateHomepageSchema } from '~/utils/schema'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { removeJwt } from "@/utils/jwt"

export default {
  data() {
    return {
    }
  },
  head() {
    return {
      title: this.title,
      bodyAttrs: {
        class: this.platform
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description
        },
        {
          name: 'robots',
          content: this.robotsContent,
          hid: 'robots-hid'
        },
        { name: 'viewport', content: 'initial-scale=1, user-scalable=no, width=device-width, height=device-height, viewport-fit=cover' }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.generateSchema()
        }
      ],
      link: [
        { rel: 'canonical', href: this.canonicalURL },
        { rel: 'preconnect', href: this.$config.CONTENT_777_API },
        { rel: 'preconnect', href: this.$config.CMS_URL },
        { rel: 'preconnect', href: this.$config.AUTH_API },
        { rel: 'preconnect', href: 'https://www.googletagmanager.com' },
        { rel: 'dns-prefetch', href: 'https://fonts.googleapis.com/' },
        { rel: 'dns-prefetch', href: 'https://maxst.icons8.com' },
        { rel: 'dns-prefetch', href: 'https://cdn.jsdelivr.net' },
        { rel: 'dns-prefetch', href: 'https://fonts.cdnfonts.com/css/din-regular' },
        { rel: 'dns-prefetch', href: 'https://fonts.cdnfonts.com/css/averta-standard' },
        { rel: 'dns-prefetch', href: 'https://fonts.cdnfonts.com/css/averta-blackitalic' },
        { rel: 'dns-prefetch', href: 'https://fonts.cdnfonts.com/css/60s-scoreboard' },
        { rel: 'preload', fetchpriority: 'high', as: 'image', href: '/images/carousel_0.png' },
        { rel: 'preload', fetchpriority: 'high', as: 'image', href: '/images/logo.svg' },
        { rel: 'stylesheet', type: 'text/css', href: 'https://sportify-static.b-cdn.net/netbet/styles.css'}
      ]
    }
  },
  watch: {
    $route: function (newValue, oldValue) {
      console.log('route change to', newValue, oldValue)

      if (newValue.path !== '/ayuda/contacto/') {
        // window.zE('messenger', 'close');
        if (typeof window !== 'undefined' && typeof window.zE === 'function') {
          window.zE('messenger', 'hide');
        }
      }

      this.$fetch()
      this.$store.commit('setHeaderTab', null)
      this.$store.commit('setBetSlipType', null)
      this.$store.commit('betbuilder/clear')
      this.$store.commit('betbuilder/setError', null)
      this.$store.commit('setBetAssistId', null)

      if (!_.includes(_.get(newValue, 'name'), 'match')) {
        this.$store.commit('setInplayEvent', null)
      }
      try {
        setTimeout(function () {
          if (!_.includes(_.get(newValue, 'name'), 'virtual')) {
            document.getElementById('main_body').scroll({ top: 0, behavior: 'smooth' })
          }
        }, 100)
      } catch (e) {}

      let modalToOpen = this.getModalToOpen(newValue)
      if (modalToOpen) {
        this.$modal.show(modalToOpen)
      }

      setTimeout(() => {
          this.checkLogin()
      }, 500)

    }
  },
  async fetch() {
    try {
      //seo
      let results = await this.$content().get('seo', {
        params: {
          path: this.$route.path,
          params: queryString.stringify(this.$route.params),
          lang: this.lang,
          country: this.country,
          bookmaker: this.$config.BOOKMAKER
        }
      })
      //seo = seo.data.data
      this.$store.commit('seo/setData', _.get(results, 'data.data.seo'))

      //globals
      let globals = await this.$cached().$get('/api/content/global', {params :{'lang' : this.lang, 'country': this.country, 'bookmaker': process.env.BOOKMAKER}});
      this.$store.commit('setGlobals', _.get(globals, 'data.global.data.attributes'))
      this.$store.commit('setBanners', _.get(globals, 'data.banners'))
      this.$root.$on('update_lang', async() => {
        let globals = await this.$cached().$get('/api/content/global', {params :{'lang' : this.lang, 'country': this.country, 'bookmaker': process.env.BOOKMAKER}});
        this.$store.commit('setGlobals', _.get(globals, 'data.global.data.attributes'))
        this.$store.commit('setBanners', _.get(globals, 'data.banners'))
      })
      this.$store.commit('betslip/setProcessingStatus', null)

      // fetch sports
      const response = await this.$content().get('sports', {
        params: { lang: this.lang, country: this.country, bookmaker: process.env.BOOKMAKER }
      })
      let sports = _.get(response, 'data.data', [])
      this.$store.commit('setSports', sports)

      if(_.includes(this.$route.name, 'esports-sport') && !_.get(results, 'data.data.breadcrumbs.sport')) {
        this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
      }
      if(_.includes(this.$route.name, 'sport-competition') && _.get(results, 'data.data.breadcrumbs.sport.translated_slug') !== _.get(this.$route, 'params.sport')) {
        this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
      }
      if(_.includes(this.$route.name, 'esports-sport') && _.get(results, 'data.data.breadcrumbs.sport.category') !== 'esport') {
        this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
      }
    } catch (e) {
      console.log(e)
    }

    try {
      const response = await this.$infoapi().$get('/v1/superbanner/home', { params: {
          lang: this.lang,
          country: 'ES',
          bookmaker: this.$config.BOOKMAKER,
          mode: this.mode,
          sport: this.sport,
        } })
      await this.$store.commit('games/setMainEvents', response.items)
    } catch (e) {
      console.log('error getting main events',e)
    }
  },
  computed: {
    canonicalURL() {
       try {
          let canonical = _.find(this.$config.CANONICALS, { 'lang': this.lang })
          if(canonical) {
            let path =  _.replace(this.$route.fullPath, "/" + this.lang, "/")
              .replace("//", "/")
              .replace(/\?register=\d{1,}/, "")

            return canonical.domain + path;
          }
      } catch (e) {
        //console.log('title', e);
      }

      return this.$config.SEO_CANONICAL + this.$route.fullPath.replace(/\?register=\d{1,}/, "")
    },
    title() {
      try {
        let variables = _.get(this.$store.state, 'seo.variables', {})
        let title = _.get(this.$store.state, 'seo.title', '')
        title = format(title, variables)
        return title
      } catch (e) {
        //console.log('title', e);
      }
      return ''
    },
    description() {
      try {
        let variables = _.get(this.$store.state, 'seo.variables', {})
        let description = _.get(this.$store.state, 'seo.description', '')
        return format(description, variables)
      } catch (e) {}
      return ''
    },
    showEsports() {
      try {
      return _.get(this.$route, 'name').includes('esports')
      } catch (e) {}
      return false
    },
    showInplay() {
      if (_.get(this.$store.state, 'inplay.sport', false) && _.includes(this.$route.name, 'match')) {
        return true
      }

      return false
    },
    noscroll() {
      if(
        _.get(this.$store.state, 'betslip.visible') &&
        _.size(_.get(this.$store.state, 'betslip.selections')) > 1 &&
        this.$device.isMobile
      ) {
        return true
      }
      return false
    },
    robotsContent() {
      if(_.has(this.$route.query, 'register')) {
        return 'NOINDEX, FOLLOW'
      } else {
        return 'INDEX, FOLLOW'
      }
    }
  },
  async mounted() {
    if(this.system === 'app') {
      try {
        CapacitorUpdater.notifyAppReady();
      } catch (e) {
        alert(e.message)
      }
      CapacitorUpdater.addListener('majorAvailable', (info) => {
        console.log('majorAvailable', info);
      });
      CapacitorUpdater.addListener('updateAvailable', (info) => {
        console.log('updateAvailable', info);
      });
      CapacitorUpdater.addListener('download', (info) => {
        console.log('download', info);
      });
    }

    // add gclid if exists
    let gclid = _.get(this.$route, 'query.gclid');
    if(gclid === undefined || !gclid.match(/^[-_0-9a-zA-Z]+$/)) {
      gclid = '';
    }
    if (gclid !== '') {
      let domain = '.' + this.$config.DOMAIN;
      this.$cookies.set('gclid', gclid, {
        maxAge: 60 * 60 * 24 * 90,
        path: '/',
        domain: domain,
        secure: true
      });
    }

    if(this.$store.state.bannersLoaded) {
      emitter.emit('banners_loaded', true)
    }

    //Safari IOS fix
    try {
        let info = await this.$CapacitorDevice.getInfo()
        this.os = info.operatingSystem;
        this.$store.commit('setOperatingSystem', info.operatingSystem)
        if(this.os === 'ios') { // to talk with Abdul about it
          window.scrollTo(0, 0);
          setTimeout(() => { window.scrollTo(0, 0) }, 300)
        }
    } catch(e) {

    }

    this.$CapacitorApp.addListener('appStateChange', async ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
      this.$store.commit('setAppState', isActive)
      if(isActive) {
        this.loadGlobalIframe('request_sport_token')
        /*this.loadGlobalIframe('hide_iframe', {}, true)
        setTimeout( () => {
          this.loadGlobalIframe('hide_iframe', {}, true)
        }, 3000)*/

        if(!this.user && this.appReady) {
          if (this.platform === 'ios' || this.platform === 'android') {
            const res = await this.$CapacitorStorage.get({ key: 'login_mode' });
            let login_mode = _.get(res, 'value')

            //trigger login
            if(login_mode === 'auto' || login_mode === 'biometric'){
              if(!this.$store.state.localAuthAt) {
                this.$root.$emit('login_force')
              }
            }
          }
        }

        try {
          this.$CapacitorNavigationBar.setColor({color: '#343743', darkButtons: false})
          //this.$CapacitorNavigationBar.hide()
        } catch (e) {
          //alert(e.message)
        }

      }

      //SPF-1239 - logging out inactive user
      if (isActive) {
        this.userAnyActionPerformed();
      }

    });

    //SPF-1239 - logging out inactive user
    ['click', 'touchstart', 'mousemove', 'mousedown', 'scroll', 'keydown'].forEach((eventName => {
      window.removeEventListener(eventName, this.userAnyActionPerformed);
      window.addEventListener(eventName, this.userAnyActionPerformed);
    }));
    setInterval(async () => {
      let lastActivity = luxon.DateTime.fromISO(localStorage.getItem('lastActivity'));
      if (!lastActivity.invalid) {
        let timeElapsed = luxon.DateTime.now().diff(lastActivity);
        if (luxon.Duration.isDuration(timeElapsed)) {
          if (timeElapsed.as('minutes') > 20 && this.user) {
            console.log("logging out inactive user")
            try {
              let result = await this.$auth().post('/api/common/logout', {session_id: this.sessionToken,});
              window.zE("messenger", "logoutUser");
            } catch (e) {
            }
            this.$store.commit('auth/clearAuthentication');
            removeJwt(this.$nuxt)
            window._alert(this.$t("You've been logged out for inactivity"));
          }
        }
      }
    }, 1000);

    try {
      setTimeout(() => { this.$CapacitorSplashScreen.hide(); }, 500);
      await this.$CapacitorStatusBar.setStyle({ style: this.$CapacitorStatusBarStyle.Dark })
      await this.$CapacitorStatusBar.setBackgroundColor({ color: '#343743' })
      this.$CapacitorNavigationBar.setColor({color: '#343743', darkButtons: false})
      //this.$CapacitorNavigationBar.hide()
    } catch (e) {
      console.log(e)
    }

    window._alert = this.alert
    window._confirm = this.confirm
    window.Capacitor = this.$Capacitor
    window.CapacitorApp = this.$CapacitorApp
    window.CapacitorDevice = this.$CapacitorDevice
    window.CapacitorGeolocation = this.$CapacitorGeolocation
    window.CapacitorNativeBiometric = this.$CapacitorNativeBiometric
    window.CapacitorStorage = this.$CapacitorStorage
    window.CapacitorHttp = this.$CapacitorHttp
    window.CapacitorSplashScreen = this.$CapacitorSplashScreen
    window.CapacitorNativeSettings = this.$CapacitorNativeSettings
    window.CapacitorNavigationBar = this.$CapacitorNavigationBar

    window.openForgotPassword = () => { this.openForgotPassword() }

    setTimeout( () => {

      window.loadGlobalIframe = this.loadGlobalIframe
    }, 3000)

    if(_.get(this.$route, 'query.affiliates')) {
      this.$cookies.set('affiliates', this.$route.query.affiliates);
    }
    if(_.get(this.$route, 'query.idaffiliation')) {
      let idAffiliation = _.get(this.$route, 'query.idaffiliation')
      let domain = ''

      if(document.domain.match(/[^\.]*\.[^\.]*$/)[0] === 'co.uk' || document.domain.match(/[^\.]*\.[^\.]*$/)[0] === 'com.mx') {
        domain = '.' + _.get(document.domain.match(/[^\.]*\.[^\.]*\.[^.]*$/), '0')
      } else {
        domain = '.' + _.get(document.domain.match(/[^\.]*\.[^.]*$/), '0')
      }

      // extension to set additional cookies
      for (const prop in this.$route.query) {
        if( prop === 'idaffiliation') continue;
        if( prop === 'click_id'){
            this.$cookies.set('click_id', this.$route.query[prop], {
            maxAge: 3600 * 24 * 30,
            path: '/',
            domain: domain,
            secure: true
          })
        }
        this.$cookies.set('affiliate_customs['+prop+']', this.$route.query[prop], {
            maxAge: 3600 * 24 * 30,
            path: '/',
            domain: domain,
            secure: true
          })
      }
      // end of the extension

      this.$cookies.set('idaffiliation', idAffiliation, {
          maxAge: 3600 * 24 * 30,
          path: '/',
          domain: domain,
          secure: true
      })
    }


    setTimeout( () => {
      window.prerenderReady = true;
    }, 1000 * 20)
    this.checkUrlSelections()



    window.CapacitorApp.addListener('appStateChange', ({ isActive }) => {
      if(isActive) {
        this.checkLogin();
      }
    });
    await this.checkLogin();

    setInterval( () => {
      //this.checkLogin();
    }, 1000 * 60)
    let modalToOpen = this.getModalToOpen(this.$route)
    if (modalToOpen) {
      this.$modal.show(modalToOpen)
    }
    await this.setConfig()
  },
  methods: {
    generateSchema() {
      if (this.$route.path === '/') {
        return generateHomepageSchema()
      }
      return {}
    },
    async setConfig() {
      try {
        let response = await this.$api().$get('/v1/config', { params: { bookmaker: this.$config.BOOKMAKER, lang: this.lang, country: this.country } })
        this.$store.commit('settings/setComboBoost', response.combo_boost)
      } catch(e) {

      }
    },
    getModalToOpen(route) {
      if (!this.$store.state.auth.user) {
        return '';
      }
      if (_.get(this.$store.state.auth.user,'require_verify')) {
        return 'modal-require-verify';
      }
      if (_.get(this.$store.state.auth.user,'ask_for_terms') &&
        route.path !== '/ayuda/terminos-y-condiciones/' &&
        route.path !== '/ayuda/politica-de-privacidad/'
      ) {
        return 'modal-accept-terms';
      }
      if (_.get(this.$store.state.auth.user,'ask_for_privacy') &&
        route.path !== '/ayuda/terminos-y-condiciones/' &&
        route.path !== '/ayuda/politica-de-privacidad/'
      ) {
        return 'modal-accept-privacy';
      }
      return '';
    },
    //SPF-1239 - logging out inactive user
    userAnyActionPerformed() {
      localStorage.setItem('lastActivity', luxon.DateTime.now().toISO())
    },

    async checkRecoveryToken() {
      console.log('checkRecoveryToken', window.location.hash)
      const parsedHash = queryString.parse(window.location.hash)
      console.log('checkRecoveryToken', parsedHash)

      if (_.has(parsedHash, 'recovery_token')) {
        let response = await this.$auth().recover(_.get(parsedHash, 'recovery_token'), true)
        console.log('parsedHash', response)
        this.$router.push({ path: '/' })
      }
    },
    async checkUrlSelections() {
      // if(this.sp) {
      //   outcome.is_starting_price = true
      //   outcome.odds = 'SP'
      //   outcome.display_odds = {
      //       "decimal": "SP",
      //       "fractional": "SP",
      //       "american": "SP"
      //   }
      // }

      // let initialBetslipSel = _.map(this.$store.state.betslip.selections, 'outcome.id')
      let stake = _.get(this.$route.query, 'combostake')
      let oddsStyle = _.get(this.$route.query, 'oddsstyle')
      let outcomeIds = []

      _.each(this.$route.query, (v,k) => {
        if(k.match(/(LineID\[\d*\])|(LineID)/)) {
          outcomeIds.push(v)
        }
      })

      if(_.size(outcomeIds)) {
        let params = {
          'lang' : this.lang,
          'bookmaker' : process.env.BOOKMAKER,
          'selections' : outcomeIds
        }
        const response = await this.$api().get('v1/betslip/validate-selections', { params: params })
        const validData  = _.get(response, 'data.data')

        if(validData) {
          //show betslip on mobile
          if (this.$device.isMobile) {
            this.$store.commit('betslip/toggleBetslip', false)
          }

          //validate stake
          if(_.endsWith(stake, '.')) {
            stake = null
          }
          //process stake
          if(stake) {
            var countDecimals = function(num) {
              var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
              if (!match) { return 0; }
              return Math.max(
                0,
                // Number of digits right of decimal point.
                (match[1] ? match[1].length : 0)
                // Adjust for scientific notation.
                - (match[2] ? +match[2] : 0));
            }

            const truncateByDecimalPlace = (value, numDecimalPlaces) => Math.trunc(value * Math.pow(10, numDecimalPlaces)) / Math.pow(10, numDecimalPlaces)
            if(countDecimals(stake) > 2) {
              stake = truncateByDecimalPlace(numeral(stake).value(),2)
            }
            stake = numeral(stake).value()
          }

          //set stake
          if(!stake) {
            let defaultStake = 10
            //If <10, default 10
            if (_.get(this.$store.state, 'betslip.stakeSingle') < defaultStake) {
              this.$store.commit('betslip/setStakeSingle', defaultStake)
            }
            if (_.get(this.$store.state, 'betslip.stakeCombi') < defaultStake) {
              this.$store.commit('betslip/setStakeCombi', defaultStake)
            }
            if (_.get(this.$store.state, 'betslip.stakeSystem') < defaultStake) {
              this.$store.commit('betslip/setStakeSystem', defaultStake)
            }

            //if >10, use latest stake.
            let lastUsedStake = _.get(this.$store.state, 'betslip.lastUsedStake');
            if(!_.isNil(lastUsedStake) && lastUsedStake > defaultStake) {
              this.$store.commit('betslip/setStakeSingle', lastUsedStake)
              this.$store.commit('betslip/setStakeCombi', lastUsedStake)
              this.$store.commit('betslip/setStakeSystem', lastUsedStake)
            }
          } else {
              this.$store.commit('betslip/setStakeSingle', stake)
              this.$store.commit('betslip/setStakeCombi', stake)
              this.$store.commit('betslip/setStakeSystem', stake)
          }

          //clear betslip
          this.$store.commit('betslip/setProcessingStatus', false)
          this.$store.commit('betslip/clear')
          this.$store.commit('betslip/setError', null)

          //set bet type
          if(_.size(validData)>1) {
            this.$store.commit('betslip/setBetType', 'combi')
            this.$store.commit('setBetSlipType', 'combi')
          } else {
            this.$store.commit('betslip/setBetType', 'single')
            this.$store.commit('setBetSlipType', 'single')
          }

          //set odds style
          if(oddsStyle) {
            this.$store.commit('settings/setOddsFormat', _.lowerCase(oddsStyle))
          }

          //add outcomes to betslip
          _.each(validData, d => {
            let outcome = _.get(d, 'outcome')
            let event = _.get(d, 'event')
            let market = _.get(d, 'market')

            //outcomes that are not already added
            // if (!_.includes(initialBetslipSel, _.get(outcome, 'id'))) {

              let eventTmp = _.omit(event, ['markets', 'market_groups']);
              this.$store.commit('betslip/add', { event: eventTmp, market: market, outcome: outcome })

              this.$root.$emit('selection_added')
            // }
          })
        }
      }
    }
  }
}
